module.exports = __webpack_public_path__ + "img/Systemplanning.ed577bf4.svg";